import React from 'react';
import HeroSection from '../components/home/HeroSection';
import CertificationsSection from '../components/home/CertificationsSection';
import AboutSection from '../components/home/AboutSection';
import ServicesSection from '../components/home/ServicesSection';
import NewsSection from '../components/home/NewsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import CTASection from '../components/home/CTASection';

const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <CertificationsSection />
      <AboutSection />
      <ServicesSection />
      <NewsSection />
      <TestimonialsSection />
      <CTASection />
    </main>
  );
};

export default HomePage;
